import { Button } from '@cian/ui-kit/button';
import { Body1, UIHeading3 } from '@cian/ui-kit/typography';

import illustrationUrl from './panoramaNotFound.svg';
import style from './style.css';

export interface IPanoramaNotFoundProps {
  onBackClick(): void;
}

/** Заглушка вкладки панорам — как `panoramaNotFound` в `object_map_view.tsx` монолита */
export const PanoramaNotFound = ({ onBackClick }: IPanoramaNotFoundProps) => (
  <div className={style['container']} data-name="PanoramaNotFound">
    <img src={illustrationUrl} alt="" width={90} height={66} />
    <div className={style['title']}>
      <UIHeading3 as="h3">Панорамы отсутствуют</UIHeading3>
    </div>
    <div className={style['text']}>
      <Body1 as="p">
        К сожалению, панорамы улиц для этой области карты
        <br />
        пока что отсутствуют
      </Body1>
    </div>
    <Button theme="main_primary" size="M" onClick={onBackClick}>
      Вернуться к карте
    </Button>
  </div>
);
